<template>
    <div class="classify classifyBase">
        <div class="borderLine borderTop title color666">拍品分类</div>
        <div class="borderLine list">
            <ul>
                <li v-for="(item) in dataList" :key="item.class_code" @click="handleClickLi(item)">
                    <a class="item">
                        <strong class="auctionFont color333 yahei">{{item.class_name}}</strong>
                        <span class="verdanF12 color666">{{item.total}}</span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import {  postStatic } from '@/api/company'
export default {
    name: "classify",
    props:['organId'],
    data(){
        return{
            dataList:[],
            organ_id:''
        }
    },
    watch:{
       'organId':function (newValue){
           if(newValue){
               this.organ_id = newValue
               this.postStatic(newValue)
           }
       }
    },
    methods: {
        postStatic(id) {
            postStatic({
                organ_code: id
            }).then(res => {
                this.dataList = res.data.organ_art_static
            })
        },
        handleClickLi(item) {
            this.$router.replace({
                query: {
                    code: item.class_code+'00000000'
                }
            })
            this.$emit('handleClickLi', item.class_code+'00000000')
        },
        codeClick(id) {
            this.$emit('handleClickLi', id+'00000000')
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/auctionCompany.scss';
</style>